import * as React from 'react';
import { Modal, Button, Tab, Table, Segment, Form, Label, Input } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../../api';

class State {
    buildVersion: string;
    installDate: string;
    deviceId: string;
    license: any;
    file: any;
    respText: any;
    showErr: boolean;
}

interface Props {
    showModal: boolean;
    handleAboutModalClose: any;
    activeIndex: number;
}

export default class AboutWindow extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            buildVersion: '',
            file: '',
            installDate: '',
            deviceId: '',
            license: '',
            respText: '',
            showErr: false
        });
        this.submit = this.submit.bind(this);
        this.handleErrModalClose = this.handleErrModalClose.bind(this);
    }
    componentDidMount() {
        this.fetchVersion();
        this.fetchLicenseInfo();
    }

    fetchLicenseInfo() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        axios.get('http://default/api/sys/deviceid')
            .then(function (response: AxiosResponse) {

                if (response.data.code !== undefined) {
                    axios.get('http://default/api/sys/license')
                        .then(function (resp: AxiosResponse) {
                            if (resp.data !== undefined) {
                                __this.setState({
                                    deviceId: response.data.deviceId,
                                    license: resp.data.licenses
                                });
                            } else {
                                // tslint:disable-next-line:no-console
                                console.log('expected system licenses, got ', resp.data);
                            }
                        })
                        .catch(function (err: AxiosRequestConfig) {
                            // tslint:disable-next-line:no-console
                            console.log('expected system licenses, got ', err);
                        });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected system deviceId, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('expected system licenses, got ', error);
            });
    }
    fetchVersion() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        axios.get('http://default/api/sys/status')
            .then(function (response: AxiosResponse) {

                if (response.data !== undefined) {
                    __this.setState({
                        buildVersion: response.data.ver,
                        installDate: response.data.installDate
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected build version, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('system status error, got: ', error);
            });
    }

    submit(oauth: OAuthClientStatus) {
        let _this = this;
        const url = 'http://default/api/sys/license';
        let formData = new FormData();
        formData.append('fileData', this.state.file);

        axios.put(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }) .then( (response) => {
            if (response.data  && response.data.code === 'SUCCESS') {
                axios.post('http://default/api/sys/restart')
                    .then(function (resp: AxiosResponse) {
                        if (resp.data !== undefined && resp.data.code === 'SUCCESS') {
                            oauth.signOut();
                        }
                    })
                    .catch(function (err: AxiosRequestConfig) {
                        // tslint:disable-next-line:no-console
                        console.log('restart error: ', err);
                    });
            } else throw response;
        })
            .catch( (error) =>  {
                _this.setState({
                    respText: error.response.data.det,
                    showErr: true
                });
            });

    }

    /*

   */
    handleErrModalClose() {
        this.setState({
            showErr: false
        });
    }
    render() {
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto',
                height: '800px',
                width: '1100px'
            }
        };
        const panes = [
            { menuItem: 'Version', render: () => this.versionTabRenderer()},
            { menuItem: 'License Details', render: () => this.licenseTabRenderer()},
            { menuItem: 'License Agreement', render: () => this.acknowledgeTabRenderer()}
        ];

        return (
            <React.Fragment>
                <Modal
                    open={this.props.showModal}
                    onClose={this.props.handleAboutModalClose}
                    size="small"
                    style={inlineStyle.modal}
                >
                    <Modal.Header className="about-window-header">About SABR-Active</Modal.Header>
                    <Modal.Content>
                        <Tab panes={panes} defaultActiveIndex={this.props.activeIndex} />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.props.handleAboutModalClose}>
                            Close
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showErr}
                    onClose={this.handleErrModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>License Failed to Activate</Modal.Header>
                        <Modal.Content>
                            {this.state.respText}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleErrModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }

    versionTabRenderer() {
        return (
            <Tab.Pane>
                <div className="versions-table">
                    <Table celled striped>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell >Version</Table.HeaderCell>
                                <Table.HeaderCell >Install Date</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell >
                                    {this.state.buildVersion}
                                </Table.Cell>
                                <Table.Cell>
                                    {this.state.installDate}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row/>
                        </Table.Body>
                    </Table>
                </div>
            </Tab.Pane>
        );
    }

    licenseTabRenderer() {
        return (
            <Tab.Pane>
                <div className="license-table">
                    <Table celled striped>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell >License Type</Table.HeaderCell>
                                <Table.HeaderCell >Version</Table.HeaderCell>
                                <Table.HeaderCell >Expiry Date</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {(this.state.license !== '' && this.state.license !== undefined) ? (this.state.license.map((object: any, i: number) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        {object.name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {object.version}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {(object.expireDate === '' ? '-' : object.expireDate)}
                                    </Table.Cell>
                                </Table.Row>
                            ))
                                : null
                            }
                        </Table.Body>
                    </Table>
                </div>
                <Segment.Group className="install-license-segment">
                    <Segment className="segment-header">Install New License</Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="system-config-label">
                                    Device ID:
                                </Label>
                                <Label className="system-config-label">
                                    {this.state.deviceId}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="system-config-label license-install-label">
                                    This Device ID is required when obtaining a license for your system.
                                    IneoQuest Technologies Inc. uses this Device ID to generate a license unique to each server.
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Input
                                    className="fileFieldWidth"
                                    type="file"
                                    label="Capability Response File:"
                                    onChange={(e: any) => this.setState({file: e.target.files[0]})}
                                />
                                <OAuth.Context>{ (oauth) => (
                                    <Button
                                        className="filterPanel-primary-btn-activate"
                                        onClick={() => this.submit(oauth)}
                                    >
                                        Activate
                                    </Button>
                                )}</OAuth.Context>
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
            </Tab.Pane>
        );
    }

    acknowledgeTabRenderer() {
        return (
            <Tab.Pane className="license-tab">
                <pre>{`
Licensing Information

1. License - By receiving and/or using this IneoQuest Technologies Inc. ("IneoQuest") software (the "Software"), you accept the following User Agreement.
Subject to the terms of this Agreement, IneoQuest grants to you a limited, non-exclusive, non-transferable license, without right to sub-license, to use
this software in accordance with this Agreement and any other written agreement with IneoQuest. This agreement is a binding legal agreement between IneoQuest
and the purchasers, users or evaluators of IneoQuest software and products. If you do not agree to be bound by this agreement, remove this Software from
your computer now and, if applicable, return to us by mail any copies of this Software in your possession.

2. Distribution - This Software shall not be copied, distributed, transferred or sub-licensed in whole or in part except that you may make one copy for
archive purposes only.

For information about redistribution of this product...
WWW:		http://www.ineoquest.com
E-mail:		sales@ineoquest.com
Phone:		1 (508) 339-2497

3. User Agreement

3.1 Use - Your license to use this Software is limited to the number of licenses purchased by you. For more information about purchasing additional
licenses of this Software please e-mail at sales@ineoquest.com You shall not allow others to use, copy or evaluate copies of this Software. Others
may obtain a copy of this software from: http://www.ineoquest.com

3.2 Use Restrictions - You shall use this software in compliance with all applicable laws and not for any unlawful purpose.   Without limiting the
foregoing, use, display or distribution of IneoQuest software together with material that is pornographic, racist, vulgar, obscene, defamatory, libelous,
abusive, promoting hatred, discriminating or displaying prejudice based on religion, ethnic heritage, race, sexual orientation or age is strictly
prohibited. Each licensed copy of the IneoQuest software may be used on one single computer location by one user.  "Use" of the software means that
you have loaded, installed, or run the software on to a computer.  If you install the software onto a multi-user platform or network, each and every
individual user of the software must be licensed separately or be covered by a site license.

You may make one copy of the licensed software for backup purposes, providing you only have one copy installed on one computer being used by one person
(or number of users covered in a site license purchase).  Other users may not use your copy of this program. If any person other than yourself uses IneoQuest
software registered in your name, regardless of whether it is at the same time or different times, then this agreement is being violated!

The sale of and or distribution of copies of this software are strictly forbidden without the prior written consent of IneoQuest.  It is a violation of
this agreement to sell, loan, rent, lease, borrow, or transfer the use of copies of IneoQuest Software products.

3.3 Copyright Restriction - You shall not, and shall not attempt to, modify, reverse engineer, disassemble or decompile this software.
IneoQuest's name and logo or graphics file that represents our software shall not be used in any way to promote products developed with our software.
IneoQuest retains sole and exclusive ownership of all right, title and interest in and to the Software and all Intellectual Property rights relating thereto.
Copyright law and international copyright treaty provisions protect all parts of IneoQuest software and products. No program, code, part, image, audio
sample, or text may be copied or used in any way by the user except as intended within the bounds of the single user program. All rights not expressly
granted hereunder are reserved for IneoQuest.

3.4 Limitation of Responsibility - You will indemnify, hold harmless, and defend IneoQuest against any and all claims, proceedings, demand and costs
resulting from or in any way connected with your use of IneoQuest software.
In no event will IneoQuest be liable for any consequential, incidental, indirect, special or punitive damages whatsoever (including, without limitation,
damages for loss of profits, loss of use, business interruption, loss of information or data, or pecuniary loss), in connection with or arising out of
or related to this Agreement, this software or the use or inability to us this software or the furnishing, performance or use of any other matters
hereunder whether based upon contract, tort or any other theory including negligence. Our entire liability, without exception, is limited to the
customers' reimbursement of the purchase price of the software (maximum being the lesser of the amount paid by you and the suggested retail price
as listed by IneoQuest) in exchange for the return of the product, all copies, registration papers and manuals, and all materials that constitute a
transfer of ownership from the customer back to IneoQuest.

3.5 Warranties - Except as expressly stated in writing, IneoQuest makes no representation or warranties in respect of this software and expressly
excludes all other warranties, express or implied, oral or written, including, without limitation, any implied warranties of merchantable quality
or fitness for a particular purpose.

Acknowledgements

This site or product includes IP2Location LITE data available from http://www.ip2location.com.
                    `}
                </pre>
            </Tab.Pane>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/aboutWindow.tsx